"use strict";

exports.__esModule = true;

exports.default = function (value) {
  return value == null;
};

module.exports = exports["default"];